import PropTypes from "prop-types";
import { useEffect, useMemo } from "react";
import { useSurveyData } from "../../../hooks/useSurveyData";
import FieldPairComponent from "./shared/FieldPairComponent";

const ExternalSurveyViewComponent = ({ data }) => {
  const { surveys, loading, fetchSurveys } = useSurveyData();

  useEffect(() => {
    fetchSurveys();
  }, [fetchSurveys]);

  const selectedSurvey = useMemo(
    () => surveys.find((survey) => survey.surveyDisplayId === data?.survey_id),
    [data?.survey_id, surveys]
  );

  return (
    <>
      <FieldPairComponent label="Survey ID">
        <span className="field-value">{data?.survey_id || "-"}</span>
      </FieldPairComponent>
      <FieldPairComponent label="Survey Name">
        <span className="field-value">
          {selectedSurvey?.surveyName || (loading ? "Loading..." : "-")}
        </span>
      </FieldPairComponent>
    </>
  );
};

ExternalSurveyViewComponent.propTypes = {
  data: PropTypes.shape({
    survey_id: PropTypes.string,
  }),
};

export default ExternalSurveyViewComponent;
